module.exports = __webpack_public_path__ + "84c829fcb86d855021bf99a22ac3ec32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss28.jpg
// module id = 734
// module chunks = 0